import { useForkRef } from './useForkRef.js';
import { isReactVersionAtLeast } from './reactVersion.js';

/**
 * Merges the rendering element's `ref` in addition to the other `ref`s.
 */
export function useRenderPropForkRef(render, ...refs) {
  let childRef;
  if (typeof render !== 'function') {
    childRef = isReactVersionAtLeast(19) ? render.props.ref : render.ref;
  } else {
    childRef = null;
  }
  return useForkRef(childRef, ...refs);
}